import React, { Component, ReactNode } from 'react';
import { CaseAttachmentLog } from '../../../../domain/case/CaseDomains';
import CaseService from '../../../../service/CaseService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import CustomLoading from '../../../custom/CustomLoading';
import LanguageUtil from '../../../../util/LanguageUtil';

class CaseAttachmentItemComponent extends Component<Props, State> {
  public state: State = new State();

  private caseService: CaseService = ServiceContainer.getInstance().get(ServiceNames.CASE);

  public render(): ReactNode {
    const { loading } = this.state;
    if (loading) {
      return <CustomLoading />;
    }
    return <div>{this.getItem()}</div>;
  }

  public componentDidMount(): void {
    this.buildData();
  }

  private getItem = () => {
    const { data } = this.state;
    const { attachment } = this.props;
    try {
      const mimetype = attachment.attachments[0].mimetype;
      const fileName = attachment.attachments[0].fileName;
      switch (mimetype) {
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/png':
          return (
            <span className={'flex justify-center'}>
              <img style={{ height: 200, width: 300 }} src={data ? URL.createObjectURL(data) : undefined} alt={fileName} />
            </span>
          );
        default:
          return (
            <div>
              <p className={'text-[#4F4F4F] text-md'}>File type: {mimetype}</p>
              <a href={data ? URL.createObjectURL(data) : undefined} download={fileName} className={'text-[#458EF7] cursor-pointer text-xs'}>
                {LanguageUtil.get({ id: 'common.label.download', defaultMessage: 'Download' })}
              </a>
            </div>
          );
      }
    } catch (e) {
      return <div>Error displaying attachment</div>;
    }
  };

  private buildData = async () => {
    const { attachment } = this.props;
    try {
      const id = attachment.attachments[0].id;
      if (id != undefined) {
        const _attachment: Blob | string | undefined = await this.caseService.getAttachment(id);
        this.setState({ data: _attachment });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };
}

interface Props {
  attachment: CaseAttachmentLog;
}

class State {
  data: any;
  loading: boolean = true;
}

export default CaseAttachmentItemComponent;
